import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class AppLoadingService {
  readonly loading = signal(false);
  readonly message = signal('');
}
